module.exports = "/assets/d2cbcda4f8f3efbac229a7c094dc87ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TF.png
// module id = 2974
// module chunks = 0